export default {"src":"__ASTRO_ASSET_IMAGE__7uo6GkGD__","width":512,"height":512,"format":"svg"}